import {Injectable} from '@angular/core';
import {ExtraFee} from "../../../models/quote/extra-fee";
import {ParametersDatabase} from "../../databases/parameters.database";

@Injectable({
    providedIn: 'root'
})
export class SqliteExtraFeeRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {}

    async getExtraFeesByCountry(): Promise<ExtraFee[]> {
        const rawExtraFees:any[] = await this.parametersDatabase.queryObjects<any>(
            `SELECT *
         FROM extrafee`,
            null,
            ['processingMode']
        );


        return rawExtraFees.map(rawExtraFee => {
            const processedExtraFee = {
                ...rawExtraFee,
                defaultChecked: rawExtraFee.defaultChecked === "1",
                checked: rawExtraFee.checked === "1"
            };
            return new ExtraFee(
                processedExtraFee.id,
                processedExtraFee.amount,
                processedExtraFee.percentage,
                processedExtraFee.type,
                processedExtraFee.defaultChecked,
                processedExtraFee.country,
                processedExtraFee.label,
                processedExtraFee.processingMode,
                processedExtraFee.role,
                processedExtraFee.serviceCode,
                processedExtraFee.checked,
                processedExtraFee.quantity,
                processedExtraFee.totalAmount
            );
        });
    }

}
